import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ParameterService } from '../../../services/parameter.service';
import { PaymentService } from '../../../services/payment.service';
import { Payment } from '../../../models/payment';

declare var paysafe: any;

@Component({
  selector: 'app-paysafe-checkout',
  templateUrl: './paysafe-checkout.component.html',
  styleUrls: ['./paysafe-checkout.component.css']
})
export class PaysafeCheckoutComponent implements OnInit {
  @Input() chamberId: string;
  @Input() paymentToken: string;
  @Input() source: string;
  @Input() userId: string;

  @Output() paymentSucces: EventEmitter<any> = new EventEmitter();
  @Output() paymentError: EventEmitter<any> = new EventEmitter();

  loading: boolean;

  private apiURL = environment.apiURL;
  private headers = new HttpHeaders({'Content-Type': 'application/json'});

  constructor(private http: HttpClient, private parameterService: ParameterService,
              private paymentService: PaymentService) { }

  ngOnInit() {
    this.loading = false;
  }

  onClickPay() {
    this.loading = true;
    this.paymentService.getPayment(this.paymentToken, this.chamberId)
    .then((payment: Payment) => {
      this.loading = false;
      paysafe.checkout.setup(payment.PaysafeCheckout.PublishableKey,
      {
        amount: payment.PaysafeCheckout.Amount,
        currency: payment.PaysafeCheckout.Currency,
        companyName: this.parameterService.getParameter().SmallLogoUrl ? '' : this.parameterService.getParameter().ShortName,
        environment: environment.production !== true ? 'TEST' : 'LIVE',
        locale: payment.PaysafeCheckout.Locale,
        imageUrl: this.parameterService.getParameter().SmallLogoUrl
      },
      this.launchPaysafePayment(this.chamberId, this.paymentToken),
      function(stage) {
        console.log(stage);
        return null;
      });
    })
    .catch((error) => {
      this.loading = false;
      this.paymentError.emit(error);
    });
  }

  private launchPaysafePayment(chamberId: string, registrationId: string) {
    return (instance, error, result) => {
      if (result.paymentMethod === 'Cards') {
        this.loading = true;
        this.PostPaysafePayment(result.token, chamberId, registrationId)
        .then(() => {
          this.loading = false;
          this.paymentSucces.emit(null);
        })
        .catch((reterror) => {
          this.loading = false;
          this.paymentError.emit(reterror);
        });
      }

      instance.close();
    };
  }

  public PostPaysafePayment(cardToken: string, chamberId: string, paymentToken: string): Promise<any> {
    let callbackUrl = this.apiURL + 'payment/' + cardToken + '/paysafe?chamberid=' + chamberId + '&paymenttoken=' + paymentToken;
    if (this.source && this.source.trim() !== '') {
      callbackUrl += '&paymentsource=' + this.source;
    }
    if (this.userId && this.userId.trim() !== '') {
      callbackUrl += '&userid=' + this.userId;
    }

    const callHeaders: HttpHeaders = this.headers;
    return this.http.post<any>(callbackUrl, null, {headers: callHeaders})
    .toPromise()
    .then(response => response)
    .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.error || error.message || error);
  }
}



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/paysafe-checkout/paysafe-checkout.component.ts